import { unref as _unref, isRef as _isRef, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "radio-group-container" }
const _hoisted_2 = { class: "grid md:grid-cols-2 gap-2 lg:gap-8 w-full" }
const _hoisted_3 = { class: "flex items-center md:items-start" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ml-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "h4 md:mb-1 text-mobile-title-tile" }, "Chcę wybrać Iek"),
  /*#__PURE__*/_createElementVNode("p", { class: "hidden md:block text-[14px] leading-[21px] lg:text-base" }, " W przypadku braku przeciwwskazań, nasi Iekаrze wystawią rесерtę na wskazany przez Ciebie Iek. ")
], -1)
const _hoisted_6 = { class: "flex items-center md:items-start" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "ml-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "h4 md:mb-1 text-mobile-title-tile" }, "Niech zdecyduje Iekаrz"),
  /*#__PURE__*/_createElementVNode("p", { class: "hidden md:block text-[14px] leading-[21px] lg:text-base" }, " Nasz Iekаrz zdecyduje o metodzie leczenia i odpowiednim Ieku podczas konsultacji. ")
], -1)
const _hoisted_9 = {
  key: 0,
  class: "error-message"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "flex flex-col w-full" }
const _hoisted_12 = { class: "h3 mt-4 mb-4 flex items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "mr-4" }, "Wybór Ieku", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  tabindex: "-1",
  class: "SearchForm__list w-full relative"
}, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "SearchForm__searchInput",
    type: "text",
    placeholder: "Wpisz nazwę Ieku"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-2xl text-primary uppercase" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "20px",
      height: "20px",
      viewBox: "0 0 20 20",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }, [
      /*#__PURE__*/_createElementVNode("title", null, "ui/search"),
      /*#__PURE__*/_createElementVNode("g", {
        id: "Page-1",
        stroke: "none",
        "stroke-width": "1",
        fill: "none",
        "fill-rule": "evenodd"
      }, [
        /*#__PURE__*/_createElementVNode("g", {
          id: "3-1-Produkt:-Zamówienie",
          transform: "translate(-898, -788)",
          fill: "#1434A4",
          "fill-rule": "nonzero"
        }, [
          /*#__PURE__*/_createElementVNode("g", {
            id: "ui/search",
            transform: "translate(898, 788)"
          }, [
            /*#__PURE__*/_createElementVNode("path", { d: "M8.20517669,16.4102244 C4.34587517,16.4100212 1.00840679,13.7202429 0.188236187,9.94909873 C-0.631934416,6.17795455 1.28693123,2.34499787 4.79754778,0.741944637 C8.30816432,-0.861108594 12.4614137,0.199137516 14.7740777,3.28876426 C17.0867417,6.37839101 16.9335765,10.6620977 14.4061593,13.5786659 C14.1667007,13.8578193 13.7961039,13.9873887 13.4348742,13.9182503 C13.0736445,13.849112 12.777086,13.5918509 12.6576337,13.2440029 C12.5381814,12.896155 12.6141233,12.5109758 12.8566675,12.2344992 C14.8491565,9.92722658 14.8443808,6.50668306 12.8454569,4.20498319 C10.8465329,1.90328332 7.46039952,1.4192986 4.89671651,3.06885876 C2.33303351,4.71841892 1.37021909,8.00066345 2.63656875,10.7737263 C3.90291842,13.5467892 7.01392691,14.9686777 9.93947026,14.1115223 C10.481727,13.955531 11.0481481,14.266838 11.2071217,14.808228 C11.3660953,15.3496179 11.0579107,15.9177439 10.517404,16.079695 C9.76637224,16.2995942 8.9877391,16.4108976 8.20517669,16.4102244 L8.20517669,16.4102244 Z" }),
            /*#__PURE__*/_createElementVNode("path", { d: "M18.9745108,20 C18.7024407,20.0003076 18.4414701,19.8921543 18.2493757,19.6994836 L12.6082959,14.0584038 C12.2139813,13.6568811 12.216899,13.0126066 12.614834,12.6146716 C13.012769,12.2167366 13.6570434,12.213819 14.0585662,12.6081335 L19.699646,18.2492133 C19.9928877,18.5425436 20.0805952,18.9836169 19.921882,19.3668185 C19.7631687,19.75002 19.3892798,19.9999108 18.9745108,20 Z" })
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "SearchForm__list",
    style: {"display":"none"}
  })
], -1)

import { useField } from 'vee-validate';
import MedicationChoose from '../MedicationChoose/MedicationChoose.vue';
import TooltipButton from '../TooltipButton.vue';


export default {
  __name: 'PrescriptionChoice',
  setup(__props) {

const { value, errorMessage } = useField('receiptPlan');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", {
          class: _normalizeClass([
          'radio-button form-radio-button p-6 lg:p-[48px] rounded-3xl border-[1px] border-greyScale-100 bg-white',
          { 'shadow-feature': _unref(value) === 'own' }
        ])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              name: "receiptPlan",
              type: "radio",
              value: "own",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(value) ? (value).value = $event : null)),
              "data-gtm-form-interact-field-id": "1"
            }, null, 512), [
              [_vModelRadio, _unref(value)]
            ]),
            _hoisted_4,
            _hoisted_5
          ])
        ], 2),
        _createElementVNode("label", {
          class: _normalizeClass([
          'radio-button form-radio-button p-6 lg:p-[48px] rounded-3xl border-[1px] border-greyScale-100 bg-white',
          { 'shadow-feature': _unref(value) === 'doctor' }
        ])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              name: "receiptPlan",
              type: "radio",
              value: "doctor",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_isRef(value) ? (value).value = $event : null)),
              "data-gtm-form-interact-field-id": "0"
            }, null, 512), [
              [_vModelRadio, _unref(value)]
            ]),
            _hoisted_7,
            _hoisted_8
          ])
        ], 2)
      ]),
      (_unref(errorMessage))
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_unref(errorMessage)), 1))
        : _createCommentVNode("", true)
    ]),
    (_unref(value) === 'own')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("h2", _hoisted_12, [
              _hoisted_13,
              _createVNode(TooltipButton, null, {
                default: _withCtx(() => []),
                tooltip: _withCtx(() => [
                  _createTextVNode(" W ramach konsultacji można wnioskować o 1 Iek ")
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_14,
          _createVNode(MedicationChoose)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

}